<template>
  <div>
    <div class="pb-3">
      <!-- create button -->
      <b-button v-has-permission="'DIESEL_CONTROL_CREATE_PERMISSION'" @click="add()" variant="dark">
        <b-icon-plus-circle></b-icon-plus-circle>
        <span class="ml-1">{{ $t('LIST_ADD_LABEL', {catalog: $t('DIESEL_CONTROL')})  | capitalize}}</span>
      </b-button>
      <!-- create button -->

      <!-- refresh button -->
      <b-button class="ml-2" @click="refresh" variant="dark">
        <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
        <span class="ml-1">{{ $t('LIST_REFRESH_LABEL')  | capitalize}}</span>
      </b-button>
      <!-- refresh button -->

      <!-- clear button -->
      <b-button class="ml-1" @click="clear" variant="dark">
        <b-icon-x></b-icon-x>
        <span class="ml-1">{{ $t('LIST_FILTER_CLEAR_LABEL') | capitalize}}</span>
      </b-button>
      <!-- clear button -->

      <!-- Excel export -->
      <download-excel class="ml-2 btn btn-dark"
                      :data="items"
                      :fields="excelFields"
                      :worksheet="labels.module"
                      :name="labels.excel">
        <b-icon-download class="mr-1"></b-icon-download>
        {{ $t('LIST_EXCEL_DOWNLOAD_LABEL') | capitalize}}
      </download-excel>
      <!-- Excel export -->
    </div>
    <div>
      <!-- List page filter -->
      <diesel-control-list-filter :only-active="onlyActive" class="d-inline-block w-75" @search="setFilter" v-model="filter"></diesel-control-list-filter>
      <!-- List page filter -->

      <!-- Page size -->
      <div class="d-inline-block pl-1 w-25">
        <page-size v-model="size"></page-size>
      </div>
      <!-- Page size -->
    </div>

    <!-- table -->
    <b-table
        id="diesel-control-table"
        ref="dieselControlTable"
        striped
        hover
        bordered
        small
        table-variant="dark"
        selectable
        :select-mode="selectMode"
        v-model="items"
        :current-page="page"
        :sort-by="sort"
        :per-page="size"
        :busy.sync="isBusy"
        :fields="fields"
        :filter="filter"
        :items="listAll">
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">{{ $t('LIST_LOADING_LABEL', {catalog: $t('DIESEL_CONTROLS')})  | capitalize}}</strong>
        </div>
      </template>

      <!-- travelCount -->
      <template #head(travelCount)="">
        <span>{{ labels.travelCount | capitalize}}</span>
      </template>

      <template #cell(travelCount)="data">
        <div style="text-align: left; vertical-align: center">
          <span>{{ data.item.travelCount }}</span>
        </div>
      </template>
      <!-- travelCount -->
<!-- pointOfRefuel -->
      <template #head(pointOfRefuel)="">
        <span>{{ labels.pointOfRefuel | capitalize}}</span>
      </template>

      <template #cell(pointOfRefuel)="data">
        <div style="text-align: left; vertical-align: center">
          <span>{{ data.item.pointOfRefuel }}</span>
        </div>
      </template>
      <!-- pointOfRefuel -->

      <template #head(enabled)="">
        <span>{{ labels.enabled  | capitalize}}</span>
      </template>

      <template #cell(enabled)="data">
        <div style="text-align: center">
          <b-icon-check-circle variant="success" v-if="data.item.enabled"></b-icon-check-circle>
          <b-icon-x-circle variant="danger" v-else></b-icon-x-circle>
        </div>
      </template>

      <template #head(options)="">
        <span>{{ $t('LIST_OPTIONS_LABEL')  | capitalize}}</span>
      </template>

      <template #cell(options)="data">
        <div style="text-align: center">
          <b-dropdown size="sm" id="dropdown-1" right class="m-md-2">
            <b-dropdown-item v-has-permission="'DIESEL_CONTROL_UPDATE_PERMISSION'" @click="edit(data.item.id)">
              {{ $t('LIST_EDIT_LABEL')  | capitalize}}
            </b-dropdown-item>
            <b-dropdown-item v-has-permission="'DIESEL_CONTROL_DELETE_PERMISSION'"
                             @click="remove(data.item.id, data.item.label)">{{ $t('LIST_DELETE_LABEL')  | capitalize}}
            </b-dropdown-item>
            <b-dropdown-item v-has-permission="'DIESEL_CONTROL_DISABLE_PERMISSION'"
                             @click="disable(data.item.id, data.item.label)" v-if="data.item.enabled"> {{ $t('LIST_DISABLE_LABEL')  | capitalize}}
            </b-dropdown-item>
            <b-dropdown-item v-has-permission="'DIESEL_CONTROL_ENABLE_PERMISSION'"
                             @click="enable(data.item.id, data.item.label)" v-else>{{ $t('LIST_ENABLE_LABEL')  | capitalize}}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <!-- table -->
  <b-container fluid>
    <b-row>
      <b-col>
        <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="size"
            pills
            aria-controls="diesel-control-table">
        </b-pagination>
      </b-col>
      <b-col class="text-right">
        {{ (pageTotals.size ? $t('GRID_ROW_TOTAL', pageTotals) : $t('GRID_ALL_ROWS_TOTAL')) | capitalize }}
      </b-col>
    </b-row>
  </b-container>
  </div>
</template>

<script>
import {Form, ProcessWithLoadingAndMessage, Table} from "@/mixins";
import DieselControls from "@/diesel-control";
import eventBus from "@/events";
import DieselControlListFilter from "@/diesel-control/DieselControlListFilter";
import PageSize from "@/components/PageSize";

export default {
  name: "DieselControlList",
  props: ['selectMode', 'currentlySelected', 'onlyActive'],
  components: {PageSize, DieselControlListFilter},
  mixins: [Table, Form, ProcessWithLoadingAndMessage],
  mounted() {
    eventBus.$on('LIST_COUNT_DIESEL_CONTROL_EVENT', (totalElements) => {
      this.totalRows = totalElements;
    });
  },
  methods: {},
  data() {
    return {
      labels: {
        travelCount: this.$t('DIESEL_CONTROL_TRAVEL_COUNT_LABEL'),pointOfRefuel: this.$t('DIESEL_CONTROL_POINT_OF_REFUEL_LABEL'),
        enabled: this.$t('LIST_ENABLED_LABEL'),
        module: this.$t('DIESEL_CONTROLS'),
        excel: this.$t('DIESEL_CONTROLS') + '.xls',
      },
        registerPage: 'DIESEL_CONTROL_REGISTER_TITLE',
      editPage: 'DIESEL_CONTROL_EDIT_TITLE',
      selectedCount: 0,
      allSelected: false,
      originals: []
    }
  },
  computed: {
    controller() {
      return DieselControls;
    },
    fields() {
      return [
        {key: 'travelCount', sortable: true, tdClass: 'customTd'},{key: 'pointOfRefuel', sortable: true, tdClass: 'customTd'},
          {key: 'enabled', sortable: true, tdClass: 'enabledTd'},
          {key: 'options', sortable: false, tdClass: 'optionsTd'}];
    },
    tableRef() {
      return this.$refs.dieselControlTable;
    },
    excelFields() {
      const fields = {};
      fields[this.labels.travelCount] = 'travelCount',fields[this.labels.pointOfRefuel] = 'pointOfRefuel'
      return fields;
    }
  }
}
</script>

<style scoped>
.selectTd {
  width: 15px !important;
}
.nameTd {
  width: 75% !important;
}
</style>
